import React from 'react';

import {StoryCrumb, CategoryLink, Container, CategoryList, CategorySeparator} from './ui';

interface Breadcrumb {
    name: string;
    href: string;
}

export interface BreadcrumbProps {
    crumbs: Breadcrumb[];
    className?: string;
}

export const Breadcrumb = ({crumbs, className}: BreadcrumbProps) => {
    if (!crumbs.length) {
        return null;
    }

    const elements = [...crumbs];
    const lastElement = elements.pop();

    return (
        <Container className={className}>
            <CategoryList>
                {elements.map((crumb, index) => {
                    return (
                        <React.Fragment key={index}>
                            <CategoryLink key={index} href={crumb.href}>
                                {crumb.name}
                            </CategoryLink>
                            <CategorySeparator>|</CategorySeparator>
                        </React.Fragment>
                    );
                })}
            </CategoryList>
            {lastElement && <StoryCrumb>{lastElement.name}</StoryCrumb>}
        </Container>
    );
};
